import { useNavigate } from "react-router-dom";
import { ArrowLeft, Shield } from "lucide-react";

export default function PrivacyPage() {
  const navigate = useNavigate();

  return (
    <div className="py-6 space-y-5" data-testid="privacy-page">
      <button
        onClick={() => navigate(-1)}
        className="flex items-center gap-2 text-sm text-muted-foreground hover:text-[#AFA8BA] transition-colors"
        data-testid="privacy-back-btn"
      >
        <ArrowLeft className="w-4 h-4" /> Retour
      </button>

      <div className="flex items-center gap-3 mb-2">
        <Shield className="w-5 h-5 text-[#7000FF]" />
        <h1 className="font-heading font-extrabold text-xl text-foreground">Politique de Confidentialite</h1>
      </div>

      <div className="bg-card border border-border rounded-3xl p-6 shadow-sm space-y-6 text-sm text-card-foreground/80 leading-relaxed">
        <p className="text-xs text-muted-foreground">Derniere mise a jour : Mars 2026</p>

        <section>
          <h2 className="font-heading font-bold text-base text-card-foreground mb-2">1. Responsable du traitement</h2>
          <p>
            Le responsable du traitement des donnees personnelles est :<br />
            <strong>kila</strong><br />
            1 A route de Bayon, 54290 Haigneville, France<br />
          </p>
        </section>

        <section>
          <h2 className="font-heading font-bold text-base text-card-foreground mb-2">2. Donnees collectees</h2>
          <p>Nous collectons les donnees suivantes :</p>
          <ul className="list-disc ml-5 mt-1 space-y-1">
            <li><strong>Donnees d'identite :</strong> pseudo, email, mot de passe (hashe), ville, photo de profil, banniere</li>
            <li><strong>Donnees d'usage :</strong> publications, commentaires, likes, reactions, mises, participations aux defis</li>
            <li><strong>Donnees de connexion :</strong> date de derniere connexion, adresse IP (logs serveur)</li>
            <li><strong>Donnees financieres :</strong> historique des transactions de credits (les paiements sont traites par Stripe, nous ne stockons pas les donnees bancaires)</li>
          </ul>
        </section>

        <section>
          <h2 className="font-heading font-bold text-base text-card-foreground mb-2">3. Finalites du traitement</h2>
          <p>Vos donnees sont traitees pour :</p>
          <ul className="list-disc ml-5 mt-1 space-y-1">
            <li>La creation et la gestion de votre compte</li>
            <li>Le fonctionnement du reseau social (publications, interactions, suivis)</li>
            <li>Le systeme de gamification (credits, mises, defis, badges, niveaux)</li>
            <li>La personnalisation de votre experience</li>
            <li>Les communications liees au service (verification email, notifications)</li>
            <li>La moderation du contenu et la securite de la plateforme</li>
          </ul>
        </section>

        <section>
          <h2 className="font-heading font-bold text-base text-card-foreground mb-2">4. Base legale du traitement</h2>
          <ul className="list-disc ml-5 space-y-1">
            <li><strong>Consentement :</strong> lors de votre inscription et de l'acceptation des CGU</li>
            <li><strong>Execution contractuelle :</strong> pour fournir les services de la plateforme</li>
            <li><strong>Interet legitime :</strong> pour la securite et la moderation</li>
          </ul>
        </section>

        <section>
          <h2 className="font-heading font-bold text-base text-card-foreground mb-2">5. Duree de conservation</h2>
          <ul className="list-disc ml-5 space-y-1">
            <li><strong>Donnees de compte :</strong> conservees tant que votre compte est actif</li>
            <li><strong>Donnees de connexion :</strong> 12 mois maximum</li>
            <li><strong>Donnees financieres :</strong> 5 ans (obligations legales)</li>
            <li><strong>Apres suppression du compte :</strong> les donnees sont supprimees sous 30 jours, sauf obligations legales</li>
          </ul>
        </section>

        <section>
          <h2 className="font-heading font-bold text-base text-card-foreground mb-2">6. Vos droits (RGPD)</h2>
          <p>Conformement au Reglement General sur la Protection des Donnees (RGPD), vous disposez des droits suivants :</p>
          <ul className="list-disc ml-5 mt-1 space-y-1">
            <li><strong>Droit d'acces :</strong> obtenir une copie de vos donnees personnelles</li>
            <li><strong>Droit de rectification :</strong> modifier vos informations via votre profil</li>
            <li><strong>Droit a l'effacement :</strong> supprimer votre compte et toutes vos donnees</li>
            <li><strong>Droit a la portabilite :</strong> telecharger vos donnees au format JSON depuis les parametres</li>
            <li><strong>Droit d'opposition :</strong> vous opposer a certains traitements</li>
            <li><strong>Droit a la limitation :</strong> demander la limitation du traitement</li>
          </ul>
          <p className="mt-2">
            Pour exercer vos droits, rendez-vous dans <strong>Parametres</strong> de votre compte ou contactez-nous.
          </p>
        </section>

        <section>
          <h2 className="font-heading font-bold text-base text-card-foreground mb-2">7. Partage des donnees</h2>
          <p>Vos donnees ne sont <strong>jamais vendues</strong>. Elles peuvent etre partagees avec :</p>
          <ul className="list-disc ml-5 mt-1 space-y-1">
            <li><strong>Stripe :</strong> pour le traitement securise des paiements</li>
            <li><strong>Mailjet :</strong> pour l'envoi d'emails transactionnels (verification)</li>
            <li><strong>Autorites competentes :</strong> en cas d'obligation legale</li>
          </ul>
        </section>

        <section>
          <h2 className="font-heading font-bold text-base text-card-foreground mb-2">8. Securite</h2>
          <p>
            Nous mettons en oeuvre des mesures techniques et organisationnelles pour proteger vos donnees :
            chiffrement des mots de passe (bcrypt), connexions HTTPS, tokens JWT a duree limitee.
          </p>
        </section>

        <section>
          <h2 className="font-heading font-bold text-base text-card-foreground mb-2">9. Cookies</h2>
          <p>
            ReallyFan utilise uniquement des cookies techniques necessaires au fonctionnement du service
            (token d'authentification). Aucun cookie publicitaire ou de tracage tiers n'est utilise.
          </p>
        </section>

        <section>
          <h2 className="font-heading font-bold text-base text-card-foreground mb-2">10. Contact</h2>
          <p>
            Pour toute question relative a vos donnees personnelles :<br />
            <strong>kila</strong><br />
            1 A route de Bayon, 54290 Haigneville, France
          </p>
        </section>

        <section>
          <h2 className="font-heading font-bold text-base text-card-foreground mb-2">11. Reclamation</h2>
          <p>
            Vous pouvez introduire une reclamation aupres de la <strong>CNIL</strong> (Commission Nationale de l'Informatique et des Libertes)
            si vous estimez que le traitement de vos donnees n'est pas conforme au RGPD.
          </p>
          <p className="mt-1">
            CNIL - 3 Place de Fontenoy, TSA 80715, 75334 PARIS CEDEX 07 -
            <a href="https://www.cnil.fr" target="_blank" rel="noopener noreferrer" className="text-[#FF6B35] hover:underline ml-1">www.cnil.fr</a>
          </p>
        </section>
      </div>
    </div>
  );
}
